import { ApiGateWay } from './../../ApiGateWay/ApiGateWay';
import { Config } from './../../config/config';
import React from 'react';
import axios from 'axios';
import Cookie from 'js-cookie';

const config = JSON.parse(Config);

async function fileDownload(documentPath) {
  let headers = {
    Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
    'Access-Control-Allow-Origin': '*',
    'x-api-key': process.env.REACT_APP_X_API_KEY,
  };
  axios
    .get(
      process.env.REACT_APP_UPLOAD_DOWNLOAD +
        config['api'] +
        '/download?objectId=' +
        documentPath,
      {
        headers: headers,
        responseType: 'blob',
      }
    )
    .then((response) => {
      //Create a Blob from the PDF Stream

      var re = /(?:\.([^.]+))?$/;

      var ext = re.exec(documentPath)[1]; // "txt"
      const MimeTypesMap = {
        png: 'image/png',
        gif: 'image/gif',
        jpg: 'image/jpg',
        jpeg: 'image/jpeg',
        pdf: 'application/pdf',
        mp4: 'video/mp4',
        doc: 'application/msword',
        docx:
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ppt: 'application/vnd.ms-powerpoint',
        pptx: 'application/vnd.ms-powerpoint',
        xlsx:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      };

      const mimeType = MimeTypesMap[ext];

      const file = new Blob([response.data], { type: mimeType });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //Open the URL on new Window
      if (mimeType === 'application/pdf') {
        window.open(fileURL, '_blank');
      } else {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', documentPath); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    })
    .catch((error) => {});
}
export const MAINTENANCE_DOCUMENTS = async (url, storeId) => {
  const fetchedData = await ApiGateWay.Get(
    config['api'] + url + '?storeId=' + storeId
  )
    .then((response) => response.json())
    .then((response) => {
      let body = [];
      let colorCodes = [];
      let proxyjson = [];
      response.maintenaceDocuments.map((name, val) => {
        body.push([val + 1, name.documentType, '', '']);
        if (name.documents) {
          name.documents.forEach((element) => {
            body.push([
              '',
              <a
                onClick={() => fileDownload(element.documentPath)}
                style={{ cursor: 'pointer' }}
              >
                {element.documentName}
              </a>,
              element.uploadedDate,
              element.uploadedBy,
            ]);
          });
        }
        colorCodes.push([0, 0, 0, 0, 0, 0]);
      });
      return (proxyjson = {
        type: 'Compliance',
        thead: ['SlNo', 'Equipment Name', 'Upload Date', 'Upload By'],
        tbody: body,
        columns: ['SlNo', 'Equipment Name', 'Upload Date', 'Upload By'],
        colorCodes: colorCodes,
      });
    });
  return fetchedData;
};

export const SAVE_MAINTENANCE = async (url, maintenanceModel) => {
  const fetchedData = await ApiGateWay.Post(
    config['api'] + url,
    maintenanceModel
  )
    .then((response) => response.json())
    .then((response) => {})
    .catch((error) => {});

  return fetchedData;
};

export const DOCUMENTS_NAME = async (url, storeId) => {
  let endpoint;
  if (url == '/loadMaintenanceDocuments') {
    endpoint = '/loadMaintenanceDocuments';
  } else {
    endpoint = '/loadComplianceAndContractList';
  }
  const fetchedData = await ApiGateWay.PostEmp(
    config['api'] + endpoint + '?storeId=' + storeId
  )
    .then((response) => response.json())
    .then((response) => {
      let body = [];
      //
      if (url == '/loadMaintenanceDocuments') {
        response.maintenaceDocuments.map((name, val) => {
          body.push([name.documentTypeId, name.documentType]);
        });
      } else if (url == '/loadCompliance') {
        response.compliance[0].documentTypes.map((name, val) => {
          body.push([name.documentTypeId, name.documentType]);
        });
      } else if (url == '/loadContract') {
        response.contracts[0].documentTypes.map((name, val) => {
          body.push([name.documentTypeId, name.documentType]);
        });
      }

      return body;
    });
  return fetchedData;
};

export const DOCUMENT_PATH = async (url, storeId) => {
  const fetchedData = await ApiGateWay.PostEmp(
    config['api'] + url + '?storeId=' + storeId
  )
    .then((response) => response.json())
    .then((response) => {
      return response.documentInfo.documentPath;
    });
  return fetchedData;
};
export const DOCUMENT_EDIT = async (url, logData) => {
  const fetchedData = await ApiGateWay.Post(config['api'] + url, logData)
    .then((response) => response.json())
    .then((response) => {
      //alert(JSON.stringify(response));
      return response;
    });
  return fetchedData;
};
